export const TechData = [
  {
    img: "img1.webp",
    name: "Cumplimiento Obligatorio",
    description: 
    "El Monitoreo de Extracciones Efectivas (MEE) requiere que los usuarios de pozos reporten el volumen extraído y el nivel del agua, mediante métodos manuales o sistemas automatizados como nuestra solución de telemetría, garantizando precisión y eficiencia en el cumplimiento.",
  },
  {
    img: "img3.webp",
    name: "Riesgos de No Cumplir",
    description:
      "No adaptarse a los estándares de la Resolución 1238 puede resultar en multas severas, desde 51 hasta 500 UTM, además de un posible daño reputacional. La fiscalización de la DGA se ha intensificado, asegurando el cumplimiento estricto.",
  },
  {
    img: "img7.webp",
    name: "Simplifica tu Cumplimiento",
    description:
      "Nuestros sistemas de telemetría automatizan el proceso de monitoreo, enviando datos directamente a la DGA. Esto minimiza errores y elimina la necesidad de registros manuales, haciendo tu gestión más eficiente.",
  },
  {
    img: "img9.webp",
    name: "Fiscalización Aumentada",
    description:
      "La DGA ha incrementado sus esfuerzos de vigilancia, utilizando tecnología avanzada para detectar incumplimientos. Asegúrate de estar en regla con nuestras soluciones de monitoreo avanzado que facilitan la adaptación a estas exigencias.",
  },
];

export default TechData;
